import { ApiError, ErrorCode, ErrorType, OptionalApiError } from 'lib/error';

export const isErrorOfType = (error: OptionalApiError, type: ErrorType) =>
  error?.type === type;

export const hasErrorOfType = (errors: Array<ApiError>, type: ErrorType) =>
  typeof errors.find(e => isErrorOfType(e, type)) !== 'undefined';

export const isErrorOfTypeAndCode = (
  error: OptionalApiError,
  type: ErrorType,
  code: ErrorCode,
) => isErrorOfType(error, type) && error?.code === code;

export const hasErrorOfTypeAndCode = (
  errors: Array<ApiError>,
  type: ErrorType,
  code: ErrorCode,
) =>
  typeof errors.find(e => isErrorOfTypeAndCode(e, type, code)) !== 'undefined';

type WithErrorHandlerState = {
  error: OptionalApiError;
  errors: Array<ApiError>;
};

export type WithErrorHandlerProps = WithErrorHandlerState & {
  setError: (error: OptionalApiError) => void;
};
